import { render } from "./Home.vue?vue&type=template&id=0c71585c&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=0c71585c&lang=scss&scoped=true"

import exportComponent from "/Users/gx/Projects/echarge/evs-fe/recharge-agreement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c71585c"]])

export default __exports__